<template>
  <div class="footer">
    <img src="../assets/images/biglogo.png" />
    <div class="footer_right">
      <div class="compony">北京维学教育科技有限公司</div>
      <div class="link">
        <span>weici@weixuetec.com</span>
        &Iota;
        <span>京ICP备16053030号</span>
        &Iota;
        <a href="javascript:;" class="wechat">
            <img src="../assets/images/wechat.png" />
            <div class="show_qrcode">
            </div>
        </a>

        &Iota;
        <span>电话：010-82809918-8020</span>
      </div>
      <div style="font-size: 15px;margin-top: 6px;">地址：北京朝阳区北苑路北辰新纪元大厦2号楼 804</div>
    </div>

    <div style="width:300px;margin:0 auto; padding:20px 0 0 0;">
      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502033934" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
        <img src="../assets/images/beian.png" style="float:left;width:20px;"/>
        <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;font-size:14px;">
          京公网安备 11010502033934号
        </p>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// Footer.vue?8b5c4954